import UIFacade from "../UIFacade";
import UISignals from "../controllers/UISignals";
import UIBaseContainer from "@baseUI/component/base/UIBaseContainer";
import MobilePortraitView from "@baseUI/views/MobilePortraitView";
import MobileLandscapeView from "@baseUI/views/MobileLandscapeView";
import DesktopView from "@baseUI/views/DesktopView";
import UIConfig from "@baseUI/config/UIConfig";
import UICreatorGraphics from "@baseUI/utils/UICreatorGraphics";
import { Signals } from "@/Imports";
import Facade from "../../src/Facade";

export default class UIMainContainer extends UIBaseContainer {
  constructor(uiModelView) {
    super();
    this.uiModelView = uiModelView;
    this.visible = false;
    this.shadow = UICreatorGraphics.addShadow(
      this,
      { x: 0, y: 0, width: UIConfig.totalWidth, height: UIConfig.totalHeight },
      0x000000,
      0.5
    );
    // this.shadow.interactive = true
    this.shadow.visible = false;
    // document.addEventListener("showPopup", this.onShowPopup.bind(this))
    // document.addEventListener("closeCustomPopUp", this.onClosePopup.bind(this))

    this.init();
    UISignals.isMobileChanged.add(this.onStartLayout, this);
    UISignals.orientationChanged.add(this.onStartLayout, this);

    UISignals.resize.add(this.onResize, this);
    UISignals.resize.add(this.onStartLayout, this);
  }

  init() {
    this.mobilePortraitLayout = new MobilePortraitView(this.uiModelView);
    this.mobileLandscapeLayout = new MobileLandscapeView(this.uiModelView);
    this.desktopLayout = new DesktopView(this.uiModelView);

    this.addChild(this.desktopLayout);
    this.addChild(this.mobileLandscapeLayout);
    this.addChild(this.mobilePortraitLayout);

    UISignals.builtAll.dispatch();
    window.dispatchEvent(new Event("resize"));
    this.onStartLayout();
  }

  onStartLayout() {
    console.log("START LAYOUT");
    const changeLayout = (newNameLayout, currentLayout, newLayout) => {
      if (!currentLayout || currentLayout.nameLayout !== newNameLayout) {
        if (currentLayout) {
          currentLayout.hide();
        }
        currentLayout = newLayout;
        currentLayout.show();
      }
      return currentLayout;
    };
    UISignals.allHide.dispatch();

    if (UIFacade.model.isMobile) {
      if (UIFacade.model.orientation === "Vm") {
        this.currentLayout = changeLayout(
          "portraitLayout",
          this.currentLayout,
          this.mobilePortraitLayout
        );
      } else {
        this.currentLayout = changeLayout(
          "landscapeLayout",
          this.currentLayout,
          this.mobileLandscapeLayout
        );
      }
    } else {
      this.currentLayout = changeLayout(
        "desktopLayout",
        this.currentLayout,
        this.desktopLayout
      );
    }
    this.currentLayout.update();
    if (Facade.model.currentState === "IDLE") {
      this.enableAll();
    }
  }

  onResize(e) {
    console.log("ON RESIZE");
    this.currentLayout && this.currentLayout.update();
  }

  showPopup() {
    this.shadow.visible = true;
  }

  closePopup() {
    this.shadow.visible = false;
  }

  updateText() {
    this.mobilePortraitLayout.updateText();
    this.mobileLandscapeLayout.updateText();
    this.desktopLayout.updateText();
  }

  setButtonState(data) {
    console.log("CURRENT LAYOUT");
    this.currentLayout.setButtonState(data);
  }
  enableAll() {
    //BonusGameContainer.showTime("ENABLE_UI")
    this.isAutospinShow =
      Facade.model.autospinList.length === 0
        ? false
        : Facade.urlParams.autoSpin;
    this.isMaxBetShow = Facade.urlParams.maxBet;
    console.log("CURRENT LAYOUT ENABLE ALL");
    document.dispatchEvent(
      new CustomEvent("setButtonState", {
        detail: {
          spin: {
            enable: true,
          },
          info: {
            enable: true,
          },
          maxBet: {
            visible: this.isMaxBetShow,
            enable: true,
          },
          plus: {
            enable: true,
          },
          minus: {
            enable: true,
          },
          autoplay: {
            visible: this.isAutospinShow,
            enable: true,
          },
          autoplayCounter: {
            enable: false,
            visible: false,
          },
          coinValue: {
            visible: true,
            enable: true,
          },
          panelBuyButtons: {
            enable: true,
          },
        },
      })
    );
    //Signals.buyButtonEnabled.dispatch();
  }
}
